export function safeAuthRedirect(destination) {
  if (typeof destination !== 'string' || !destination.startsWith('/') ||
      destination.startsWith('//') || /[\\\u0000-\u001f\u007f]/.test(destination)) {
    return '/dashboard';
  }
  try {
    const url = new URL(destination, window.location.origin);
    if (url.origin !== window.location.origin || url.pathname.startsWith('//') ||
        url.pathname.startsWith('/login') || url.pathname.startsWith('/auth/callback') ||
        url.pathname === '/admin' || url.pathname.startsWith('/admin/')) {
      return '/dashboard';
    }
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return '/dashboard';
  }
}

export function consumeAuthRedirect() {
  const intendedRoute = localStorage.getItem('intendedRoute');
  const pendingShareCode = sessionStorage.getItem('pendingShareCode');
  const redirectAfterLogin = sessionStorage.getItem('redirectAfterLogin');
  const destination = intendedRoute || (pendingShareCode ? `/t/${encodeURIComponent(pendingShareCode)}` : redirectAfterLogin);
  localStorage.removeItem('intendedRoute');
  sessionStorage.removeItem('pendingShareCode');
  sessionStorage.removeItem('redirectAfterLogin');
  return safeAuthRedirect(destination);
}
